/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_Desc_PlaceholderInputs */

const en_admin_users_credits_desc_placeholder = /** @type {(inputs: Admin_Users_Credits_Desc_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Optional reason`)
};

const zh_admin_users_credits_desc_placeholder = /** @type {(inputs: Admin_Users_Credits_Desc_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`操作原因（可选）`)
};

/**
* | output |
* | --- |
* | "Optional reason" |
*
* @param {Admin_Users_Credits_Desc_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_desc_placeholder = /** @type {((inputs?: Admin_Users_Credits_Desc_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_Desc_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_users_credits_desc_placeholder(inputs)
	return zh_admin_users_credits_desc_placeholder(inputs)
});
export { admin_users_credits_desc_placeholder as "admin.users.credits_desc_placeholder" }